import { createFileRoute } from '@tanstack/react-router';
import { CatalogoUsuarioPerfil } from '@/features/catalogo/page/default/usuario/perfil/CatalogoUsuarioPerfil';

export const Route = createFileRoute('/p/catalogo/$slug/_default/usuario/perfil')({
    component: CatalogoUsuarioPerfil,
});
